<template>
  <px-custom-dialog v-model="dialog"
                    content-class="rounded-card"
                    :width="dialogWidth">
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind:on="on">
        <v-btn icon
               v-on="on">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </slot>
    </template>
    <template v-slot:title>
      Edição de saldo
    </template>
    <template>
      <div class="text--primary">
        <v-row dense class="mt-3">
          <v-col cols="12">
            <span class="title font-weight-bold">
              {{ saldo.saldo }} UN
            </span>
            <px-entrega-produto-saldo-situacao :situacao="saldo.situacaoEntrega"/>
          </v-col>
        </v-row>
        <template v-if="saldoEdicao">
          <v-row>
            <v-col>
              <px-select-enum dense
                              :clearable="false"
                              class="rounded-tag-small"
                              v-model="saldoEdicao.situacaoEntrega"
                              :items="situacoesSaldos"
                              label="Situação"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <px-date-picker dense
                              class="required"
                              input-class="rounded-tag-small"
                              label="Previsão de faturamento"
                              v-model="saldoEdicao.dataPrevisaoFaturamento"/>
            </v-col>
          </v-row>
          <v-row v-if="isSaldoFaturado || isSaldoEntregue">
            <v-col>
              <px-date-picker dense
                              class="required"
                              input-class="rounded-tag-small"
                              label="Data de faturamento"
                              v-model="saldoEdicao.dataFaturamento"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <px-date-picker dense
                              class="required"
                              input-class="rounded-tag-small"
                              label="Previsão de entrega"
                              v-model="saldoEdicao.dataPrevisaoEntrega"/>
            </v-col>
          </v-row>
          <v-row v-if="isSaldoEntregue">
            <v-col>
              <px-date-picker dense
                              class="required"
                              input-class="rounded-tag-small"
                              label="Data de entrega"
                              v-model="saldoEdicao.dataEntrega"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-textarea
                dense
                outlined
                auto-grow
                hide-details
                label="Observações internas"
                rows="3"
                class="rounded-tag-small"
                v-model="saldoEdicao.observacaoInterna"/>
            </v-col>
          </v-row>
        </template>
      </div>
    </template>
    <template v-slot:actions>
      <v-btn class="elevation-0 rounded-tag-small normal-btn-text"
             color="primary"
             :loading="loading"
             @click="onClickSave"
      >
        Salvar
      </v-btn>
      <v-btn class="elevation-0 rounded-tag-small normal-btn-text"
             @click="cancel">
        Cancelar
      </v-btn>
    </template>
  </px-custom-dialog>
</template>

<script>
import { SituacaoGestaoEntregaProdutoSaldo } from 'px-business-components';
import GestaoEntregaService from '@/modules/gestao-entregas/gestao-entrega-service';

export default {
  props: {
    saldo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      saldoEdicao: null,
      situacoesSaldos: SituacaoGestaoEntregaProdutoSaldo.values.filter(
        situacao => situacao.key !== SituacaoGestaoEntregaProdutoSaldo.keys.CANCELADO.key,
      ),
    };
  },
  computed: {
    isSmall() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    dialogWidth() {
      return this.isSmall ? '90%' : '800px';
    },
    isSaldoEntregue() {
      return this.saldoEdicao.situacaoEntrega
        === SituacaoGestaoEntregaProdutoSaldo.keys.ENTREGUE.key;
    },
    isSaldoFaturado() {
      return this.saldoEdicao.situacaoEntrega
        === SituacaoGestaoEntregaProdutoSaldo.keys.FATURADO.key;
    },
  },
  methods: {
    cancel() {
      this.dialog = false;
    },
    buildPayload() {
      return {
        situacaoEntrega: this.saldoEdicao.situacaoEntrega,
        dataPrevisaoFaturamento: this.saldoEdicao.dataPrevisaoFaturamento,
        dataFaturamento: (this.isSaldoFaturado || this.isSaldoEntregue)
          ? this.saldoEdicao.dataFaturamento : null,
        dataPrevisaoEntrega: this.saldoEdicao.dataPrevisaoEntrega,
        dataEntrega: this.isSaldoEntregue ? this.saldoEdicao.dataEntrega : null,
        observacaoInterna: this.saldoEdicao.observacaoInterna,
      };
    },
    onClickSave() {
      this.loading = true;
      GestaoEntregaService.updateSaldoEntrega(this.saldo.id, this.buildPayload())
        .then(({ data }) => {
          this.$emit('change', data);
          this.cancel();
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    dialog(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.saldoEdicao = {
        ...this.saldo,
      };
    },
  },
};
</script>
